const CryptoJS = require('crypto-js');

module.exports = function encrypt({ data, initVector, Securitykey }) {
  const options = {
    mode: CryptoJS.mode.CBC,
    iv: CryptoJS.enc.Hex.parse(initVector),
  };
  return CryptoJS.AES.encrypt(
    data,
    CryptoJS.enc.Hex.parse(Securitykey),
    options
  ).toString();
};
